module.exports = "/_next/static/images/cableDesign2-a08e895b239ccd1e61628b8d7c33ba12.webp";